module.exports = __webpack_public_path__ + "img/news-title-xl.9a70078a.png";